import { filterConfigs } from '@aibees/elephant/feature/search-filters';
import { SearchTable } from '@aibees/elephant/types';
import { Maybe } from '@aibees/shared/definition';

export function useBaseFilterByName(
  searchTable: Maybe<SearchTable>,
  name: string
) {
  if (searchTable)
    return filterConfigs[searchTable].filter((x) => x.name === name)?.at(0);
  return undefined;
}
